/**
 * @voltxampere/ui — 4017 decade counter CMOS variant (Sprint 41-5, placeholder)
 *
 * PLACEHOLDER per ADR-0061 §"MVP DC-only scope". Drag-drop and
 * schema persistence work today; the simulate path returns vLow
 * because sequential clock-edge counter logic needs the transient
 * state machine layer that lands in Sprint 42+.
 *
 * Reference: TI CD4017. Engine zero-diff invariant honored.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic4017 = {
    id: "4017",
    nameTr: "4017 (Onluk Sayıcı CMOS, DIP-16, placeholder)",
    nameEn: "4017 (Decade Counter CMOS, DIP-16, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "4017",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "D-FLOP",
        vHigh: 5,
        vLow: 0,
        threshold: 2.5,
        propagationDelay: 200e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-4017.js.map